export default __webpack_public_path__ + "static/media/imagecommingsoon.28b74eed.jpeg";